import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useGlobalContext } from '../stores/global';

interface Props extends Omit<RouteProps, 'component'> {
  component: React.ComponentType<any>;
}

export default function ProtectedSellerRoute({
  component: Component,
  ...rest
}: Props) {
  const { user } = useGlobalContext();

  return (
    <Route
      {...rest}
      render={(props) =>
        user && user.role === 'vendedor' ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}
